import type { RawProductBrandRef } from "../../../../../../types";
import type { TransformedBrand } from "../../../types/productApiTypes";

/**
 * A pure helper function to transform the raw brand references from the main product object.
 * Note: Brand names are not translated in this theme's structure as they come directly
 * from the product object, not a separate translatable taxonomy endpoint.
 *
 * @param rawBrands The `brands` array from the raw product object. Can be undefined.
 * @returns A new array of transformed brand objects.
 */
export const transformBrands = (
  rawBrands: RawProductBrandRef[] | undefined
): TransformedBrand[] => {
  if (!Array.isArray(rawBrands)) {
    return [];
  }

  // The raw and transformed structures are identical, so this is just a mapping
  // to create a new array and ensure type correctness.
  return rawBrands.map((brand) => ({
    id: brand.id,
    name: brand.name,
    slug: brand.slug,
    link: brand.link,
  }));
};
